// src/reducers/index.js
import { combineReducers } from "redux";
import galleryReducer from "./galleryReducer";
import artistReducer from "./artistReducer";
import libraryCardReducer from "./libraryCardReducer";
import blogReducer from "./blogReducer";
import storeReducer from "./storeReducer";
import collectionReducer from "./collectionReducer";

const rootReducer = combineReducers({
  gallery: galleryReducer,
  artist: artistReducer,
  libraryCards: libraryCardReducer,
  blog: blogReducer,
  store: storeReducer,
  collections: collectionReducer,
});

export default rootReducer;
